import { StateAdminModel } from "./models";

export const stateAdmin: StateAdminModel = {
  categories: [],
  services: [],
  roles: [],
  groups: [],
  selectedGroup: ''
};
